import { createSlice, PayloadAction, current } from "@reduxjs/toolkit";
import { Messages, getMessage } from "./messages";

export interface InputNames {
  // ログイン画面
  username: string;
  password: string;
  newPassword: string;
  confirmNewPassword: string;
  code: string;
  // ユーザー一覧画面
  typeCode: string;
  permissionCode: string;
  companyName: string;
  referenceGroupCode: string;
  statusCode: string;
  email: string;
  // ユーザ登録更新画面
  companyType: string;
  companyId: string;
  familyName: string;
  givenName: string;
  memo: string;
  comment: string;
  roleId: string;
  userReferenceGroups: string;

  // ユーザプロファイル画面
  emailVerifyCode: string;
  // ID払い出し結果受領・取込画面
  idList: string;
  selectItem: string;

  //加盟店一覧
  corporateNumber: string;
  dunsNo: string;
  merchantName: string;
  storeName: string;
  ipid: string;
  siteId: string;
  shopId: string;
  creditCardMerchantNumber: string;
  merchantManagementNumber: string;
  shopCode: string;
  businessCode: string;
  settlementGroupId: string;
  accessKey: string;

  // 変更相談内容申請
  merchantConsultation: string;

  // 入金口座一覧画面
  applicantCompanyName: string;
  referenceGroupName: string;
}

export interface ErrorText {
  inputName: keyof InputNames;
  msg: string;
}

interface MsgObj {
  msgId: keyof Messages;
  msgArgs: string[];
}

export interface ValidationState {
  msg: string;
  //各項目チェックMsg
  formFieldErrTxts: ErrorText[];
  //相関チェックMsg
  formErrTxt: string;
}

const initialState = {
  msg: "",
  formFieldErrTxts: [] as ErrorText[],
  formErrTxt: "",
} as ValidationState;

const validationSlice = createSlice({
  name: "validation",
  initialState,
  reducers: {
    //! deprecated! Do not use
    createValidationMsg: (state, action: PayloadAction<keyof Messages>) => {
      const msgId = action.payload;
      state.msg = getMessage(msgId).label;
    },
    //! deprecated! Do not use
    clearValidationMsg: (state) => {
      state.msg = "";
    },
    createFormFieldErrTxts: (
      state,
      action: PayloadAction<{
        name: keyof InputNames;
        msgId: keyof Messages;
        msgArgs: string[];
      }>
    ) => {
      const { name, msgId, msgArgs } = action.payload;
      const { formFieldErrTxts } = current(state);

      let updatedFormFieldErrTxts = [...formFieldErrTxts];
      let updatedFormFieldErrTxt = updatedFormFieldErrTxts.find(
        (txt) => txt.inputName === name
      ) || {
        inputName: name,
        msg: "",
      };

      if (!updatedFormFieldErrTxts.find((txt) => txt.inputName === name)) {
        updatedFormFieldErrTxts = [
          ...updatedFormFieldErrTxts,
          updatedFormFieldErrTxt,
        ];
      }

      updatedFormFieldErrTxt = {
        ...updatedFormFieldErrTxt,
        msg: getMessage(msgId, ...msgArgs).label,
      };

      updatedFormFieldErrTxts = updatedFormFieldErrTxts.map((txt) =>
        txt.inputName === name ? updatedFormFieldErrTxt : txt
      );

      state.formFieldErrTxts = [...updatedFormFieldErrTxts];
    },
    clearFormFieldErrTxt: (state, action: PayloadAction<keyof InputNames>) => {
      const name = action.payload;
      const { formFieldErrTxts } = current(state);

      let updatedFormFieldErrTxts = [...formFieldErrTxts];
      updatedFormFieldErrTxts = updatedFormFieldErrTxts.filter(
        (txt) => txt.inputName !== name
      );

      state.formFieldErrTxts = [...updatedFormFieldErrTxts];
    },
    clearAllErrTxts: (state) => {
      state.formFieldErrTxts = [];
      state.formErrTxt = "";
    },
    createFormErrTxt: (state, action: PayloadAction<MsgObj>) => {
      const { msgId, msgArgs } = action.payload;
      state.formErrTxt = getMessage(msgId, msgArgs).label;
    },
    clearFormErrTxt: (state) => {
      state.formErrTxt = "";
    },
  },
});

export const {
  createValidationMsg,
  clearValidationMsg,
  createFormErrTxt,
  clearFormErrTxt,
  createFormFieldErrTxts,
  clearAllErrTxts,
  clearFormFieldErrTxt,
} = validationSlice.actions;

export default validationSlice.reducer;
